import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import MainDrawer from "@layout/MainLayout/MainDrawer";
import MainAppBar from "./MainAppBar";

const Component = ({
  drawerWidth,
  onToggle,
  container,
  mobileOpen,
  user,
  onLogout,
  onHome,
}) => {
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Grid
          sx={{
            width: 271,
            bgcolor: "background.paper",
            borderRight: "1px solid rgba(0, 0, 0, 0.12)",
            display: {
              xs: "block",
              sm: "block",
              md: "block",
              lg: `none`,
              xl: `none`,
            },
          }}
        >
          <MainDrawer onHome={onHome} />
        </Grid>
        <MainAppBar
          drawerWidth={drawerWidth}
          onLogout={onLogout}
          onHome={onHome}
          user={user}
        />
        <Box
          component="nav"
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "none",
              lg: `block`,
              xl: `block`,
            },
            width: {
              xs: drawerWidth,
              sm: drawerWidth,
              md: drawerWidth,
              lg: drawerWidth,
              xl: drawerWidth,
            },
            flexShrink: { sm: 0 },
          }}
          aria-label="mailbox folders"
        >
          <Drawer
            variant="permanent"
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "none",
                lg: `block`,
                xl: `block`,
              },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                backgroundColor: "background.paper",
              },
            }}
            open
          >
            <MainDrawer onHome={onHome} />
          </Drawer>
        </Box>
      </Box>
    </>
  );
};

export default Component;
